/**
 * Secure storage wrapper — uses sessionStorage (dies on tab close).
 * Values are base64-encoded to avoid casual inspection in DevTools.
 * NOT encryption — just obfuscation. For real security, use a backend.
 */

const PREFIX = 'vsm_sec_'
function encode(value: string): string {
  try {
    return btoa(unescape(encodeURIComponent(value)))
  } catch {
    return value
  }
}
function decode(value: string): string {
  try {
    return decodeURIComponent(escape(atob(value)))
  } catch {
    return value
  }
}
export const secureStorage = {
  set(key: string, value: string) {
    try {
      sessionStorage.setItem(PREFIX + key, encode(value))
    } catch {}
  },
  get(key: string): string | null {
    try {
      const raw = sessionStorage.getItem(PREFIX + key)
      return raw ? decode(raw) : null
    } catch {
      return null
    }
  },
  remove(key: string) {
    try {
      sessionStorage.removeItem(PREFIX + key)
    } catch {}
  },
  has(key: string): boolean {
    return this.get(key) !== null
  },
  /** Clear all secure keys */
  clearAll() {
    try {
      const keys = Object.keys(sessionStorage).filter((k) =>
        k.startsWith(PREFIX),
      )
      keys.forEach((k) => sessionStorage.removeItem(k))
    } catch {}
  },
}

// Storage keys
export const KEYS = {
  OPENAI_API_KEY: 'openai_api_key',
  OPENAI_MODEL: 'openai_model',
  CONFLUENCE_USER: 'confluence_user',
  CONFLUENCE_PASS: 'confluence_pass',
  CONFLUENCE_TOKEN: 'confluence_token',
  CONFLUENCE_TOKEN_EXPIRY: 'confluence_token_expiry',
  JIRA_USER: 'jira_user',
  JIRA_PASS: 'jira_pass',
  JIRA_TOKEN: 'jira_token',
  JIRA_TOKEN_EXPIRY: 'jira_token_expiry',
  GITHUB_TOKEN: 'github_token',
} as const
